export default function Profike() {
  return "Profil"
}
